import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

// Shared section scaffolding: one rhythm and one type scale across the proof
// stack, so the page reads as one voice while each section keeps its own layout
// (the opposite of an identical card grid). The heading scale deliberately runs
// a little larger than the app chrome's 2.25rem cap — the landing is the one
// "loud moment" surface (see the brief / DESIGN.md note), still well under 3rem
// and never an all-caps eyebrow.

export function Section({
  id,
  labelledBy,
  className,
  children,
}: {
  id?: string;
  labelledBy?: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <section
      id={id}
      aria-labelledby={labelledBy}
      className={cn("py-[clamp(4rem,8vw,7rem)]", className)}
    >
      <div className="mx-auto w-full max-w-6xl px-6 sm:px-8">{children}</div>
    </section>
  );
}

export function SectionHeading({
  id,
  className,
  children,
}: {
  id?: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <h2
      id={id}
      className={cn(
        "text-balance font-display text-[clamp(1.75rem,1.1rem+2.4vw,2.5rem)] font-semibold leading-[1.12] tracking-tight text-foreground",
        className,
      )}
    >
      {children}
    </h2>
  );
}

export function SectionLead({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <p
      className={cn(
        "text-pretty text-[clamp(1.05rem,1rem+0.3vw,1.2rem)] leading-relaxed text-foreground/75",
        className,
      )}
    >
      {children}
    </p>
  );
}
